import { useEffect, useLayoutEffect, useRef } from 'react';

export const mergeRefs = (...refs) => {
  const filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 0) return filteredRefs[0];
  return (inst) => {
    for (const ref of filteredRefs) {
      if (typeof ref === 'function') {
        ref(inst);
      } else if (ref) {
        ref.current = inst;
      }
    }
  };
};

const updateRef = (ref, innerRef) => {
  if (!ref) return;
  if (typeof ref === 'function') {
    ref(innerRef.current);
  } else {
    // eslint-disable-next-line no-param-reassign
    ref.current = innerRef.current;
  }
};

export const useForwardedRef = (ref) => {
  const innerRef = useRef(null);
  useLayoutEffect(() => updateRef(ref, innerRef));
  useEffect(() => updateRef(ref, innerRef));
  return innerRef;
};
